import React, {createContext, useCallback, useContext, useState} from "react";
import {addSupplier, deleteSupplier, fetchSuppliers, updateSupplier} from "./api/api";
import { useAuthenticatedEffect } from "./components/useauthenticatedeffect";

const SupplierContext = createContext();

export const useSuppliers = () => useContext(SupplierContext);

export const SupplierProvider = ({ children }) => {
    const [suppliers, setSuppliers] = useState([]);
    const [error, setError] = useState('');

    const fetchAllSuppliers = useCallback(async () => {
        try {
            const supplierData = await fetchSuppliers();
            setSuppliers(supplierData);
        } catch (error) {
            console.error('Error fetching suppliers from context:', error);
        }
    }, []);

    // useEffect(() => {
    //     fetchAllSuppliers();
    // }, [fetchAllSuppliers]);

    const createSupplier = async (newSupplier) => {
        try {
            const addedSupplier = await addSupplier(newSupplier);
            setSuppliers([...suppliers, addedSupplier]);
            setError('');
        } catch (error) {
            console.error('Error adding supplier:', error);
            setError('Error adding supplier. Please try again.');
        }
    };

    const updateSupplierDetails = async (supplier) => {
        try {
            const updatedSupplierData = await updateSupplier(supplier);
            setSuppliers(suppliers.map(supplier => supplier.id === updatedSupplierData.id ? updatedSupplierData : supplier));
        } catch (error){
            console.error('Error updating supplier:', error);
            setError('Error updating supplier. Please try again.');
        }
    };

    const removeSupplier = async (supplierId) => {
        try {
            await deleteSupplier(supplierId);
            setSuppliers(suppliers.filter(supplier => supplier.id !== supplierId));
        } catch (error) {
            console.error('Error deleting supplier:', error);
        }
    };

    // useAuthenticatedEffect(() => {
    //     fetchAllSuppliers().then(r => r); // added then(r => r) to remove warning
    // });

    useAuthenticatedEffect(
        useCallback(() => {
            fetchAllSuppliers().then(r => r); // added then(r => r) to remove warning
        }, [fetchAllSuppliers])
    );

    return (
        <SupplierContext.Provider value={{
            suppliers,
            error,
            fetchAllSuppliers,
            createSupplier,
            updateSupplierDetails,
            removeSupplier,
        }}>
            {children}
        </SupplierContext.Provider>
    );
};